import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import LandingHeader from '../components/organisms/LandingHeader';
import Footer from '../components/organisms/Footer';
import Button from '../components/atoms/Button';
import { getCourses } from '../services/secureApi';
import { checkEnrollment } from '../services/secureApi';
import { useAuth } from '../hooks/useAuth';
import CourseModuleList from '../components/CourseModuleList';
import SessionManager from '../utils/sessionManager';

// Company logos that hire from this course
const companyLogos = [
  { name: 'Zoho', logo: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQ4AAACUCAMAAABV5TcGAAABa1BMVEX///8ImUkibbTkJSf5sh0AAADiAAD5sBD5sRf6vlIAmEb/+/b6tyz5rgD+9Of6tjL7yGn6uk37y3cAlT/BwcHkHiA5drPn5+fd3d0AYq/ttUVlZWUAX64UaLIAV6sAWqwAkDH98/PjExYLCwv86up0dHQyMjJ/f3/1+Pv0sLCwsLBBQUH519fnREb3y8vwkpPg8ObpXF3uhobv9/L1u7uSstbg6fOkvdulpaUgICCPj4/Pz8/D4s/sdXVnk8at173P3e3lMTJRqm3xoaGAwJboT1BUVFQAih24zONOhcCVyaZvuYgZcqaEpM4Zd504oVr82aP458qlmX9afaS/oWYAgV4ZgorTqVcKkVnP3c6Ro3sThXfDQio7jkYwmmdRjbqhZkArfpFVi0yyXDzROy1sg0v947hOkKtSpnb70omAeUZphqK9TjOPckWMiF25x7GKvrA4l3e7dl9lrJVtoWzLalt1gJFioKzm3s8HTrXaAAAR2klEQVR4nO2d+UMaRxvHWYhoNzG2JQtiWDnEdDUoIIjRcKsJRwht7jRN3zZH7/R98x59++e/M7PHPAszew1E38bvLzGyLrsfnnNmdgiFLnShs1YJ6ayv4Xyo0upm7hJJw3rlrK/mjFXqZjIxSZecuRsbfsxGUhpaLEwimXH9rK/qrNSSM9KUYnfHg4/RZyqDCdOgJiKffHQ+UxnclZk0dJ/52IJIneEoNp/pfkxBpC6xPQUAyYxbH0sQKf3kbBx/vSCSLxTyWd6LLRsNWY7FZFYkkTN/gUokv7u1t5OLYkXKW3nGEaUucBU5JnWHwzGbCIqq3XkVq5qmzefEhrL56nFjh3DIKREsBVEp704dCIxDlrtGiGh1ZaaJoEpktkFE02rt3sGoqabUeH/Uq80cSja7Wy02iEUYHIBy0XLBfjg0DnlIb7U+lJlEULk2mIHPIGtotxGGeDi1nk6n1HA4rKrox2ZvZkCy2cJWsRwhBjFNwlA0smX7I5BkY0PbB186kThABIKIhjlgcwgnU+l0UsUcoNT1fi3ouU1lszhElHNRpkVMSInugQ+gNLSMIzZVXVQG41kFEUShhtxif9RX19cxhzBP6vp+UAPJIoPY3WqcRjyBMHnkGvQMsAIbTL8BavkldhDxWolY5hAPJ9fTKQcOltJN3zwQCBwrO86eweGh7Fm3e2LhmDYOA9iQ7TMx5yCiUbdIr7PcwkGpuGcemEMBx0o/BjHJo2PGj+eSdaOxE95blk7G3CDyfMpEMAbiFs045pBKesdAefS10GVnERI4RHRI0sgFAmEod6pXIKiTte7NaXADBRGmz9iDiMEBuwXG4Mce7FLD6f2vvvz5UyeFiqfRIBahYJF/4S/18FEa00A6dDRKHESYRHAlgn1Gq/VGcd9uwYbRf7C27KZQ1K9B6CA6nc5OubjX2IkAHsoOqcdawDhajjhCOIiwTYQEkV4z5ZQu3AgQGTAePlpcXrzkppBPDujmMYi9rV2jW6meQgMphmwl2ETNwRYKIiwgsvz4fqAQQTiQf+NYOo0Hi8uuLLziABwaxa2CvW3L7lH7ypVR9Kjfte6IlWVZPjOYTryy9CTs1y4sa4j3m6P9XhsX57VeM6zGny4veaHhhgN4xt5xtcDsX7N7UeotVXsJ5rXOREHEbiLys/s+YKi6QSBbQBwOem1759ZrrnkyDQccigli57TcON4t8O4DK39K7aMYqoNuxZtx6LIFEUTDi5+Y5oAw9JuGOUzr6opXGgwcFES5sXdcYHXvk9qyzCPX8FCC8USDSMyNhuUVwC14uuydhg0HsAgcIryA0FWgOMqgBJO5JRgXiB5EcNzge4WOgekWTH3uLWwAHNAzipwQ4SDqLcrp1w7NmwdVWshnYi/iU4EDmAPi4GgOdn11BeJYWnRUCPVehkGgWJn3bhFQeSuYKt+8pJWDcwnGVX34rT2MGhzu/c3NLZj6BFQbS0sra2ufOSikdE5R0tgNxsFQ9tjE0fmOuop7CcbTAUixajh+7/73T148fhY7CTJi9sMlahyLV54+eDhy7Fka0wN7/lWNmsbxChhH0PG+WhPG0fvvpUwmg8dZM0HmMj8FNFaOUincx81bVix9TY3DYwnGUK8PfOWJFLOyr+Q/GF1dWaQ0Hiaxtc0fR75DCnXlzVva2XsuwaZ0AGzjhQxG5ANMZP5AA+nyEaGsCg8Tuipf1lPLb9IMjEMbWb6S/PEnW62a8W0eP1uhY/mpfs71D4CjESXG8cssjKPWtHwl3iaVCIhHfs/6qeUry78aOHpBL8yzssWo3TgClGCW2lboSDZreKQRFHa+owdIs0Ytk9oPfGWehVOL0nkHjCP47DzFkSKj35UB5eE7uXxi+sriWtw46SjwlXnWLo4dMyjBsHoTOJB9UMx+vWUah9oMfmleVYgoMyrBbM5izI3UrdFG3yGJgeNDZFrUtbyZRQkWsuEY6VmgQodQ/AaPaRzh9Q+AA6WW17MxDlCUqs22/quBhcNvqmXhmH+mRallVsYB6g413tZ/NQhcebBwtAUuzqOq0dezKMGI9i0cYaNGoLllBjjS8y88UGqZSQlGtG+VYapx5TS1zADHhyg8Ct8A4wheghHR/j55oGdaK5T6rsMYOD5Epk38LjYKBtWLT2Ta1lgOangsHH2xy/OiksgQ6YQmM23lhCYWvwsNGTjC6twzrW2W+u+CJ6M9nJ5paRUmZfyuIWPhSM0904JZavntseDJajTT9tvo/yd0AMj30w5MHG3BC3RTBSwUfPldw/0PHKWNQIePjAPM+foeLmXhmHumhQsFX3UaficmJmXPtLTokGO+gzTTOuadacFasPE7Mm8tJDo6mOrZ5nz9Dw6ycCTn3OLDFuvVae5UdHC+Rz/IA60FjMN/K8TMLHPOtHCh4C8RZWfL/U8cZcu0QRYEUDFxzLfFB7PU0svfFKUjnFqadHjwH+PgQ2EhiGOlb7lgcq44noPB7l86kQhdURlQoMXvv6fGMQ7QClEcV+iI9FxbfFCCSS9fK3hVg+AZaYufvP8sJmIcEAfNV3Nt8UvUnKW3eP5JPLVYLX74BV0BIz0PcCaAo2fhSB8IXp+TbCUYno3LnTouFvKgA+PKVWAcwWasAY5Vmr7nmGkrsAR7oxgrxMTUM1p89YkkMkEbsuFIWDjmmWnroHl7p0/VkvWUIjLmFtR7j0VKMCyA4zJdJqFyjxctqKeNA3mLaGoxCg9oHAFKMCyIwyo8wuvc40XdvB4DWVYxF8wJnlTPtOq990IlGBbE0aQ4uJlW0M0nSjBzwZxgatEzrfoElGABpyogjhHFwe1pBd0cjIKh+txcPyicWnCNoMbf09HocZAsG7LjoJ0hP9OWg16xLrAc/+U/rfWDwqkFX7n6vWAJhgVxtGmm5bb4O0GvmAj2skNrta1410IG00EJFnjPD4ijRjMtdzA9F/B9dNGKVB63dq3VtuKZNq7CEiwTqATDgjg0D4VHVCjTlkDorxSspek50QExnGmFSzAsiCNEe1puix8VGqsp0dAxDBU65pMtwqml1kyJl2BYNhw003IH06NCbl6n02Mn1oK5GaSW2iglXoJh2XDQTJtuc44XK5nsOOhabNHUoo1gCSawh4MNB2jxeYVHTii12JyFrsWmz5AG1T4owQSMw46j555plWjw90I4ZDh7Wp1dajmAo2ABSzAsGw5aeHAzbUQotdAJFnk8gM+1iHYtrWdCQ6SWbDg8ZNpIVCTqgdlkuVuCqUUs04LzxoS2XbPhCNHBdF6LH4kKuTko0qXhnzS1TG7o4VNgIjLzL5GBXjsOuvaft15O0K7hQgbp3/+ZVdcyoLPUz35sC5zIjsO9xY+IpRbY4MvSO9NZBLsWOEv94p7IDLMdh3umjYilFrgbgyS9tcp0sbmWARg//z45Oxw00/Ja/EgkKlRQw1kW6ZUyk9QCZ6kf30sfCEya2XG0LevgTVtHxFKLbTGD/KozkyaOzlJLsSfmyvRgsuPQ6OAxJ9NGBFOLbTe9V9/QTPtn4BNC4/j2vmouxQ4kO44QbWk5mRbhEB33bsXMyydzknrsePN1K2in0RpD40AV5Oxw0BY/zTY5/EEGfzddLXNlmD4LR/TmrTQcBCqgYAmGNybQF4gF1AQO10yLk2LwdzPU6mZkOw78lGBM7p4E2D4PLBQkj1tbK9ODaAKH67Q1unSxATGi5ycZDAQ6C35oMhYbn/jePo8+nmDuWiGQaSdw0MF0Bxyi0wAh8uy8lJHNaTj6gDECMvS3fR6sz/Vn8UUKj0nr8IJDdHCCqFQ/GVszLRHlN/NJMDnmL4jYSjBiHCmBwsN/7IhERQcnDFWeW8aBcNDiDO/P6TmI2EswVS+ZgqeWibqDJlpOD0dGNgO/m035Bthl6jtQuyMgstcgAhYKmrt4JAUyLa9n4dcdyDwCvxtUAdCAexNIVhDxUInYjMPYt0Kk8JgYDbNw8Fa8zAZHtlAtluFWbK+lKaFiresaROz1ufFBCmRaC8fylctwqwPe8rCIYGrBm1cW9xrlnQjwFOXN76wd4/Ug4nS2yRLM4BE8tXyytLS4iPeLu/RoH2wZo/K2YyQ4Ao3V5AvVYwzitKPk7NtXKpG9UqsbYwJBpZlDEIHPatAdb1LBcXy2vLiy9vTRg6M/HsJt+rhT+ASHz64Fb16JOJR3OhFEQpnarhBPwlVKrWEsw9o9z6ESqYASbPxfy9MDZlqt1js4+uKPPx4+jMfDtj0LucZBcHgeEMvmd6vHBEQkl2OB0GkYI4OoEpFYQGRuEIEl2AA8fO4z0+J9n/dHzWafYABbD1qRg2tu5AbcR4Cy+cIWBnG6o7uGwwaWSsQaGKzUB2M/QQQYh1SnK9O9xlLNxiGZnKRgpRX+xrb65+k0dpVHsbKhg1ByihMI/VyRY9ADVUgQYWywGJNQ4p0IInCIdFgCWwAlXUaANBMDtQcmB+Nscb6x6ffArNOz+aoBwsk1pjxla6IjREFE9hREQM1BJiJB0RRnW/eEOThTsGiobT5Yw8DtI9+ojNBDRKfDjJV8GNHy7nR/jIIIJ6qiIGIBKQ1BzYEXCtIHSJG72KOpvtHvyKM52D3F0fNMh+80yJcDGCB0z/DgGlBKNMr+hgG3IFIhB8BdbchCQbDrDeLRJJvhA7egOw/6kJp2LnGte8l1ymU9RHj3DEoC75TcaVT5X0GBgwgbiDzuDofdLvz+EuPJ5APbneBdBoOYA4SRij94+rmDQvCWcp5iJQNEtIN3pnPbtLFUZ1cicgwLblZqLGHQbPupYQJBOZC/TmEYVxx3HfSxuS8ThII3+q3ibybxMqTGq0QmZO0P1pveijEIiGQqlQzf+/XB07WVReftKQPhyBGL2GkUt5BF5PkOwvQZdhCBonP22r4IDowhva72fz168OjR07W1lSUXGAhH1P3uoUGQ3dRNEJ4sYhoIDiIOJhKT6Gof+sC1L3NAfpFKqnhH04N2rfbnyqUreGdOD/uWhhoeeegh4rRRrAYGYYkXRKZoEB7eDQS7Bf4aErLRL+JQM76u5oclz3sdZ9146LFSOd0rVv16Bl8VTiWC4sbEvkG1kXvsVAmH9VS4P7I42E7ylbdtwREOvMCNs3M8AZHrkD2wPcZKH0Ces4JILDOcXAim9eJch9GjJKpJyEa/1BymdHXNw57xBAeqvMrRKMsidho4aYh6Bh/IVBBhfx+JVttXUxMWYloDwODc1Vz9csULEHJsfrdBvmZBUfRYiQqq4lZhfiBMVUgQycR0ZTLdVok5MqS19+PkaxaIV6TW01Z0cMVg6TIGsrzsvNXxonFwNr9VxB0KjpVbu/m5g7CETOSkO0bqnnBYEKEehXw3Td/NKxx0+erVLz9fcRY9OpvX9aFAWKpUKqVSqeI27UC+uMiHObB0GSFxVPBTX+hCF7rQhS50oQtd6EIX+v/S6vVNS9vco7Tt6zdv3Lx+K8E/UeLW5uY145xHm5urDu95bROd7M6Rw8nOStqthQ1TC5u8rmv75uEC1uEh/x5Wry8sfKG/un1jYeEa9y2v3TncwCfbOOS+35kJ4bB0eMv9GPOOpwVw3HLCgVmZunnuDCSxfQ3rC3Rxm5xDtjGqo4SWIHdyxPlIPeK4dpMw1bRtbHDXzx0PotU7Cwt3brNfu41eu7Ft/XjIuVGPONBRC9cI0QQGw3nPs5V2xHcVYhxHxs+3+ObhDQc2sE3DJPBh59I8bju4SgKhumHeHDYPTtLwFko3F+hLGjrZwjnEsXqT7yrkNq0XEyjG3GQfiY87vEGEMwcHB/aVVfif8+ctCSdXsePQoKlMHwfEx7Fhw8FPyGelaw6ugm5zc8I6RHGcc+twdBXDP8ybs7GZOA26ueu3E0iaQyi1ETiPscPZVUJ6NjFfx8WCe2ZxCKWYlHkC/Dmcu0LM2VXwATcs80jgxMDpbLzhSNyh3oIt5dY5q9NXD92SPw6fuocQGrwq3WPPcoTebwO/mMA0Ns6ZcZA73Nhw7Fn0IHmot3GOCdlLC3eHtG9GT3jeAuk2zAZHnINA0uDHXK8tHKnEDDmNApyJPOEwGi+QYRjCbY/R/uOA63DkbWIgCzec4ve5V2J1hn4+05Nd6EI2/Q+l2B946oNXWgAAAABJRU5ErkJggg==' },
  { name: 'TATA', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Tata_logo.svg/200px-Tata_logo.svg.png' },
  { name: 'Capgemini', logo:'data:image/png;base64,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'},
  { name: 'Google', logo: 'data:image/png;base64,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' },
  { name: "L'Oreal", logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/L%27Or%C3%A9al_logo.svg/200px-L%27Or%C3%A9al_logo.svg.png' },
];

// Default course data for fallback
const defaultCourse = {
  title: 'Professional Course',
  subtitle: 'Advance your career with industry-relevant skills',
  category: 'Professional Development',
  rating: 4.5,
  reviews_count: 500,
  students_enrolled: 5000,
  duration_weeks: 8,
  level: 'Intermediate',
  price: 9999,
  provider: 'NexaSure Academy',
  last_updated: 'December 2024',
  language: 'English',
  certificate: true,
  what_you_learn: [
    'Industry-relevant practical skills',
    'Real-world project experience',
    'Best practices and methodologies',
    'Career advancement strategies',
  ],
  skills: ['Problem Solving', 'Communication', 'Technical Skills', 'Project Management'],
  modules: [
    { title: 'Foundation Module', duration: '2 weeks', lessons: 10 },
    { title: 'Core Concepts', duration: '3 weeks', lessons: 15 },
    { title: 'Advanced Topics', duration: '2 weeks', lessons: 12 },
    { title: 'Capstone Project', duration: '1 week', lessons: 5 },
  ],
  instructors: [
    { name: 'Expert Instructor', title: 'Industry Professional', company: 'Leading Company', image: 'https://randomuser.me/api/portraits/men/1.jpg', students: 10000, courses: 5 },
  ],
  testimonials: [
    { name: 'Student Name', role: 'Professional', text: 'Great course with practical insights.', rating: 5, image: 'https://randomuser.me/api/portraits/men/2.jpg' },
  ],
  outcomes: [
    { metric: '85%', label: 'Career advancement' },
    { metric: '40%', label: 'Salary increase' },
    { metric: '4.5/5', label: 'Student satisfaction' },
  ],
};

const tabs = ['About', 'Outcomes', 'Modules', 'Testimonials'];

const CourseDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { currentSession, role, isLoading } = useAuth();
  
  // Get session from SessionManager (OLD - uses localStorage)
  const candidateSession = SessionManager.getSession('candidate');
  const candidateId = candidateSession?.user_id;
  const token = candidateSession?.access_token;
  
  const [activeTab, setActiveTab] = useState('About');
  const [course, setCourse] = useState(null);
  const [allCourses, setAllCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedModule, setExpandedModule] = useState(null);
  const [isEnrolled, setIsEnrolled] = useState(false);

  useEffect(() => {
    const loadCourseData = async () => {
      setLoading(true);
      try {
        // Fetch all courses from API
        const courses = await getCourses();
        setAllCourses(courses);
        
        // Find the specific course
        const foundCourse = courses.find(c => c.id === id);
        
        if (foundCourse) {
          // Use API course data with fallbacks for missing fields
          setCourse({
            ...defaultCourse,
            ...foundCourse,
            // Explicitly preserve API values
            reviews_count: foundCourse.reviews_count || foundCourse.review_count || 0,
            students_enrolled: foundCourse.students_enrolled || 0,
            rating: foundCourse.rating || 4.5,
            // Format price for display
            price: foundCourse.price,
            // Ensure arrays exist
            what_you_learn: foundCourse.what_you_learn || defaultCourse.what_you_learn,
            skills: foundCourse.skills || defaultCourse.skills,
            modules: foundCourse.modules || defaultCourse.modules,
            instructors: foundCourse.instructors || defaultCourse.instructors,
            testimonials: foundCourse.testimonials || defaultCourse.testimonials,
            outcomes: foundCourse.outcomes || defaultCourse.outcomes,
          });
        } else {
          // Fallback to default course if not found
          setCourse({ ...defaultCourse, id, title: `Course: ${id}` });
        }
      } catch (error) {
        console.error('Error loading course:', error);
        setCourse({ ...defaultCourse, id, title: `Course: ${id}` });
      } finally {
        setLoading(false);
      }
    };

    loadCourseData();
  }, [id]);

  // Check enrollment status - runs once on mount and when id changes
  useEffect(() => {
    const checkEnrollment = async () => {
      const loggedIn = !!currentSession;
      const isCandidate = role === 'candidate';
      const candidateId = currentSession?.user_id;
      
      console.log('CourseDetailPage: Checking enrollment', { 
        loggedIn, 
        isCandidate, 
        candidateId,
        courseId: id
      });
      
      if (!loggedIn || !isCandidate || !candidateId) {
        console.log('CourseDetailPage: Not authenticated properly');
        setIsEnrolled(false);
        return;
      }
      
      // Check enrollment directly by candidate_id and course_id
      try {
        console.log('CourseDetailPage: Checking enrollment in database');
        
        const session = SessionManager.getCurrentSession() || SessionManager.getSession('candidate');
        const token = session?.access_token;
        const response = await fetch(
          `${process.env.REACT_APP_API_URL || 'https://aptirix-version-610696728606.asia-south1.run.app/api'}/course-teaching/check-enrollment/${id}?candidate_id=${candidateId}`,
          {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
          }
        );
        
        console.log('CourseDetailPage: Enrollment check response status', response.status);
        
        if (response.ok) {
          const data = await response.json();
          console.log('CourseDetailPage: Enrollment status:', data.is_enrolled);
          setIsEnrolled(data.is_enrolled || false);
        } else {
          console.error('CourseDetailPage: Failed to check enrollment', response.status);
          setIsEnrolled(false);
        }
      } catch (error) {
        console.error('CourseDetailPage: Error checking enrollment:', error);
        setIsEnrolled(false);
      }
    };
    
    if (!isLoading) {
      checkEnrollment();
    }
  }, [id, currentSession, role, isLoading]);

  const handleEnroll = () => {
    // Get fresh session data from SessionManager
    const candidateSession = SessionManager.getSession('candidate');
    const hasValidSession = candidateSession && candidateSession.access_token;
    
    console.log('🔐 CourseDetailPage handleEnroll check:', { 
      hasValidSession,
      candidateSessionExists: !!candidateSession,
      isEnrolled,
      currentSession: !!currentSession,
      role
    });
    
    // Check if user is logged in as candidate
    if (!hasValidSession) {
      console.log('❌ No valid candidate session, redirecting to login');
      alert('Please log in to enroll in this course.');
      navigate('/login');
      return;
    }
    
    // Check if already enrolled - navigate to progress page
    if (isEnrolled) {
      console.log('✅ Already enrolled, navigating to course progress page');
      navigate(`/candidate/courses/${id}/progress`);
      return;
    }
    
    console.log('✅ Navigating to billing page');
    // Navigate to billing page
    navigate(`/course-billing/${id}`);
  };

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background-light dark:bg-background-dark">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col bg-background-light dark:bg-background-dark">
      <LandingHeader />
      
      <main className="flex-1">
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-[#0d1b2a] to-[#1b263b] text-white">
          <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8">
            <div className="grid gap-8 lg:grid-cols-3">
              <div className="lg:col-span-2">
                <span className="inline-block rounded-full bg-primary/20 px-3 py-1 text-sm font-medium text-primary">
                  {course.category}
                </span>
                <h1 className="mt-4 text-3xl font-bold sm:text-4xl lg:text-5xl">{course.title}</h1>
                <p className="mt-4 text-lg text-gray-300">{course.subtitle}</p>
                <div className="mt-6 flex flex-wrap items-center gap-4 text-sm">
                  <span className="flex items-center gap-1">
                    <span className="text-yellow-400">★</span> {course.rating || 4.5} ({(course.reviews_count || 0).toLocaleString()} reviews)
                  </span>
                  <span>{Math.max(course.students_enrolled || 0, 20).toLocaleString()} students enrolled</span>
                </div>
                <div className="mt-4 flex flex-wrap gap-4 text-sm text-gray-300">
                  <span>Created by {course.provider}</span>
                  <span>Last updated {course.last_updated}</span>
                  <span>{course.language}</span>
                </div>
              </div>
              {/* Enrollment Card */}
              <div className="rounded-2xl bg-white p-6 text-gray-900 shadow-xl">
                <div className="text-center">
                  <p className="text-3xl font-bold text-primary">₹{course.price?.toLocaleString('en-IN')}</p>
                  <p className="mt-1 text-sm text-gray-500 line-through">₹{(course.price * 1.5)?.toLocaleString('en-IN')}</p>
                </div>
                <Button className="mt-4 w-full" onClick={handleEnroll}>
                  {currentSession && token && role === 'candidate' && isEnrolled ? 'Continue Learning' : 'Enroll Now'}
                </Button>
                <p className="mt-3 text-center text-xs text-gray-500">30-Day Money-Back Guarantee</p>
                <hr className="my-4" />
                <ul className="space-y-2 text-sm">
                  <li className="flex items-center gap-2"><span className="text-green-500">✓</span> {course.duration_weeks} weeks of content</li>
                  <li className="flex items-center gap-2"><span className="text-green-500">✓</span> {course.level} level</li>
                  <li className="flex items-center gap-2"><span className="text-green-500">✓</span> Certificate of completion</li>
                  <li className="flex items-center gap-2"><span className="text-green-500">✓</span> Lifetime access</li>
                  <li className="flex items-center gap-2"><span className="text-green-500">✓</span> Mobile & desktop access</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Company Logos */}
        <section className="border-b bg-white py-6 dark:bg-gray-900">
          <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
            <p className="text-center text-sm text-gray-500 dark:text-gray-400">
              Learners from this course work at
            </p>
            <div className="mt-4 flex flex-wrap items-center justify-center gap-8">
              {companyLogos.map((company) => (
                <img key={company.name} src={company.logo} alt={company.name} className="h-8 object-contain grayscale hover:grayscale-0 transition" />
              ))}
            </div>
          </div>
        </section>

        {/* Tabs Navigation */}
        <section className="sticky top-0 z-10 border-b bg-white shadow-sm dark:bg-gray-900">
          <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
            <div className="flex gap-8 overflow-x-auto">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`whitespace-nowrap border-b-2 py-4 text-sm font-medium transition ${
                    activeTab === tab
                      ? 'border-primary text-primary'
                      : 'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400'
                  }`}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Tab Content */}
        <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8">
          {/* About Tab */}
          {activeTab === 'About' && (
            <div className="grid gap-12 lg:grid-cols-3">
              <div className="lg:col-span-2 space-y-12">
                {/* What You'll Learn */}
                <div className="rounded-2xl border bg-white p-8 dark:bg-gray-900 dark:border-gray-800">
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white">What you'll learn</h2>
                  <ul className="mt-6 grid gap-4 sm:grid-cols-2">
                    {course.what_you_learn?.map((item, idx) => (
                      <li key={idx} className="flex items-start gap-3">
                        <span className="mt-1 text-green-500">✓</span>
                        <span className="text-gray-700 dark:text-gray-300">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Skills You'll Gain */}
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Skills you'll gain</h2>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {course.skills?.map((skill) => (
                      <span key={skill} className="rounded-full bg-primary/10 px-4 py-2 text-sm font-medium text-primary">
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Instructor (Aptirix AI) */}
                {(() => {
                  const aiInstructor = course.instructors?.find(i => i.role === 'instructor') || course.instructors?.[0];
                  const preparedBy = course.instructors?.find(i => i.role === 'prepared_by');
                  return (
                    <>
                      {aiInstructor && (
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Instructor</h2>
                          <div className="mt-6">
                            <div className="flex gap-4 rounded-xl border bg-white p-6 dark:bg-gray-900 dark:border-gray-800">
                              <img src={aiInstructor.image} alt={aiInstructor.name} className="h-20 w-20 rounded-full object-cover" />
                              <div className="flex-1">
                                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">{aiInstructor.name}</h3>
                                <p className="text-sm text-primary font-medium">{aiInstructor.title}</p>
                                {aiInstructor.bio && <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">{aiInstructor.bio}</p>}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {preparedBy && (
                        <div>
                          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Course Prepared By</h2>
                          <div className="mt-6">
                            <div className="flex gap-4 rounded-xl border bg-white p-6 dark:bg-gray-900 dark:border-gray-800">
                              <img src={preparedBy.image} alt={preparedBy.name} className="h-20 w-20 rounded-full object-cover" />
                              <div className="flex-1">
                                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">{preparedBy.name}</h3>
                                <p className="text-sm text-primary font-medium">{preparedBy.title}</p>
                                {preparedBy.bio && <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">{preparedBy.bio}</p>}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  );
                })()}
              </div>

              {/* Sidebar - Course Info */}
              <div className="space-y-6">
                <div className="rounded-2xl border bg-white p-6 dark:bg-gray-900 dark:border-gray-800">
                  <h3 className="font-semibold text-gray-900 dark:text-white">This course includes:</h3>
                  <ul className="mt-4 space-y-3 text-sm text-gray-600 dark:text-gray-400">
                    <li className="flex items-center gap-3">📹 {course.modules?.reduce((acc, m) => acc + m.lessons, 0) || 0} video lessons</li>
                    <li className="flex items-center gap-3">📚 {course.modules?.length || 0} modules</li>
                    <li className="flex items-center gap-3">⏱ {course.duration_weeks} weeks duration</li>
                    <li className="flex items-center gap-3">📱 Access on mobile and desktop</li>
                    <li className="flex items-center gap-3">🏆 Certificate of completion</li>
                    <li className="flex items-center gap-3">♾️ Lifetime access</li>
                  </ul>
                </div>
              </div>
            </div>
          )}

          {/* Outcomes Tab */}
          {activeTab === 'Outcomes' && (
            <div className="space-y-12">
              <div className="text-center">
                <h2 className="text-3xl font-bold text-gray-900 dark:text-white">Career Outcomes</h2>
                <p className="mt-2 text-gray-600 dark:text-gray-400">What our learners achieved after completing this course</p>
              </div>
              <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {course.outcomes?.length > 0 ? course.outcomes.map((outcome, idx) => (
                  <div key={idx} className="rounded-2xl border bg-white p-8 text-center dark:bg-gray-900 dark:border-gray-800 shadow-sm">
                    <p className="text-4xl font-bold text-primary">{outcome.metric || outcome.title}</p>
                    <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">{outcome.label || outcome.description}</p>
                  </div>
                )) : (
                  <div className="col-span-full text-center py-8 text-gray-500">
                    No outcome data available for this course yet.
                  </div>
                )}
              </div>
              <div className="rounded-2xl bg-gradient-to-r from-primary/10 to-blue-500/10 p-8">
                <h3 className="text-xl font-bold text-gray-900 dark:text-white">Job Roles You Can Apply For</h3>
                <div className="mt-4 flex flex-wrap gap-3">
                  {['Full Stack Developer', 'Frontend Developer', 'Backend Developer', 'Software Engineer', 'Web Developer', 'React Developer'].map((role) => (
                    <span key={role} className="rounded-full bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm dark:bg-gray-800 dark:text-gray-300">
                      {role}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Modules Tab */}
          {activeTab === 'Modules' && (
            <div className="space-y-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 dark:text-white">Course Curriculum</h2>
                <p className="mt-2 text-gray-600 dark:text-gray-400">
                  {course.modules?.length || 0} modules • {course.modules?.reduce((acc, m) => acc + (m.lessons || 0), 0) || 0} lessons • {course.duration_weeks} weeks
                </p>
              </div>
              
              <CourseModuleList 
                courseId={id}
                modules={course.modules || []}
                candidateId={currentSession?.id}
                token={token}
                isEnrolled={isEnrolled}
              />
            </div>
          )}

          {/* Testimonials Tab */}
          {activeTab === 'Testimonials' && (
            <div className="space-y-12">
              <div className="text-center">
                <h2 className="text-3xl font-bold text-gray-900 dark:text-white">What Our Learners Say</h2>
                <p className="mt-2 text-gray-600 dark:text-gray-400">Real stories from real students</p>
              </div>
              <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                {course.testimonials?.length > 0 ? course.testimonials.map((testimonial, idx) => (
                  <div key={idx} className="rounded-2xl border bg-white p-6 dark:bg-gray-900 dark:border-gray-800 shadow-sm">
                    <div className="flex items-center gap-4">
                      {testimonial.image ? (
                        <img src={testimonial.image} alt={testimonial.name || testimonial.student} className="h-12 w-12 rounded-full object-cover" />
                      ) : (
                        <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center text-primary font-bold">
                          {(testimonial.name || testimonial.student || 'U').charAt(0).toUpperCase()}
                        </div>
                      )}
                      <div>
                        <h4 className="font-semibold text-gray-900 dark:text-white">{testimonial.name || testimonial.student}</h4>
                        <p className="text-sm text-gray-500">{testimonial.role || 'Student'}</p>
                      </div>
                    </div>
                    <div className="mt-4 flex text-yellow-400">
                      {[...Array(testimonial.rating || 5)].map((_, i) => <span key={i}>★</span>)}
                    </div>
                    <p className="mt-4 text-gray-600 dark:text-gray-400">"{testimonial.text || testimonial.comment}"</p>
                    {testimonial.date && (
                      <p className="mt-2 text-xs text-gray-400">{testimonial.date}</p>
                    )}
                  </div>
                )) : (
                  <div className="col-span-full text-center py-8 text-gray-500">
                    No testimonials available for this course yet.
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* More Courses Section */}
        <section className="border-t bg-gray-50 py-16 dark:bg-gray-900/50">
          <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white">More Courses You Might Like</h2>
            <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {allCourses.filter(c => c.id !== id).slice(0, 3).map((c) => (
                <div
                  key={c.id}
                  onClick={() => navigate(`/courses/${c.id}`)}
                  className="cursor-pointer rounded-2xl border bg-white p-6 transition hover:shadow-lg dark:bg-gray-900 dark:border-gray-800"
                >
                  <span className="text-xs font-medium text-primary">{c.category}</span>
                  <h3 className="mt-2 font-semibold text-gray-900 dark:text-white">{c.title}</h3>
                  <div className="mt-2 flex items-center gap-2 text-sm text-gray-500">
                    <span>★ {c.rating || 4.5}</span>
                    <span>•</span>
                    <span>{c.duration_weeks} weeks</span>
                  </div>
                  <p className="mt-4 text-lg font-bold text-primary">₹{c.price?.toLocaleString('en-IN')}</p>
                </div>
              ))}
            </div>
            <div className="mt-8 text-center">
              <Button variant="secondary" onClick={() => navigate('/courses')}>
                View All Courses
              </Button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default CourseDetailPage;
